export default __webpack_public_path__ + "static/media/learnifyX.fe361c48.jpg";